import { Container as ContainerBase, styled } from '@mui/material'

export const Root = styled('div')`
  background-color: ${props =>
    props.color === 'blue' ? props.theme.palette.blue[20] : props.theme.palette.brand.gray3};
  height: ${props => props.height};
  position: relative;
  width: 100%;

  #jumbotron {
    display: flex;
  }
  #jumbotron canvas {
    position: absolute;
  }
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    padding: 16px 16px 8px;
    position: relative;
    z-index: 2;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding: 11px 38px 40px;
    }
  }
`
